export default __webpack_public_path__ + "static/media/6.50af7d0d.png";